import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "disposition-body" }

import { ref, computed } from "vue";
import { Button, Modal, Select } from "@/components/ui";
import { useCallDispositions, useLogCallLogDetails } from "@/composables/calls";
import { useToast } from "@/composables/ui/useToast";


export default /*@__PURE__*/_defineComponent({
  __name: 'CallDispositionRequiredModal',
  props: {
    callSid: {}
  },
  emits: ["saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $toast = useToast();
const { data: callDispositionsData } = useCallDispositions();
const callDispositions = computed(() => callDispositionsData.value || []);
const { mutateAsync: logCallLogDetails } = useLogCallLogDetails();

const selectedDisposition = ref<any>(null);
const isSaving = ref(false);

async function save() {
  if (!selectedDisposition.value) return;
  isSaving.value = true;
  try {
    await logCallLogDetails({
      callSid: props.callSid,
      callDispositionId: selectedDisposition.value.id,
    });
    $toast.success("Call disposition saved.");
    emit("saved");
  } catch (error) {
    $toast.error("Failed to save disposition. Please try again.");
  } finally {
    isSaving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: true,
    size: "xs",
    showCloseButton: false,
    closeOnBackdrop: false,
    closeOnEscape: false,
    zIndex: 10060
  }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("h2", { class: "disposition-header__title" }, "Save Call Disposition", -1)
    ]))]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "disposition-required__description" }, " Please select a disposition for this call before continuing. ", -1)),
        _createVNode(_unref(Select), {
          modelValue: selectedDisposition.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDisposition).value = $event)),
          options: callDispositions.value,
          placeholder: "Choose call disposition",
          "label-key": "name",
          "value-key": "id",
          "return-object": true
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "primary",
        disabled: !selectedDisposition.value || isSaving.value,
        loading: isSaving.value,
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isSaving.value ? "Saving..." : "Save Disposition"), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _: 1
  }))
}
}

})